import { ContactInfoFieldType } from '@/api/affiliate/serv/oec_affiliate_creator_marketplace_api';
var getContactInfo = function getContactInfo(contactInfo, id) {
  var info = (contactInfo === null || contactInfo === void 0 ? void 0 : contactInfo.find(function (item) {
    return item.field === id;
  })) || {
    field: ContactInfoFieldType.WHATS_APP,
    value: '',
    title: '',
    country_code: ''
  };
  return info;
};
export var checkContactInfo = function checkContactInfo(contactInfo, id) {
  var _getContactInfo;
  return (_getContactInfo = getContactInfo(contactInfo, id)) !== null && _getContactInfo !== void 0 && _getContactInfo.value ? 'true' : 'false';
};